import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Skeleton,
} from '@mui/material';
import TextWrapper from '../../formUtilities/useTextWrapper';
import CloseIcon from '@mui/icons-material/Close';

export const DialogWrapper = ({
	state,
	title,
	content,
	actions,
	subTitle = '',
	maxWidth = 'lg',
	loading = false,
	centerHeading = false,
	hideCloseBtn = false,
	titleClass = '',
	contentClass = '',
	footerClass = '',
	onClose,
}) => {
	return (
		<Dialog
			maxWidth={maxWidth}
			fullWidth={true}
			open={state}
			onClose={(e) => {
				onClose && onClose(false);
			}}>
			{
				<Box>
					<>
						<DialogTitle className="text-center">
							<Box
								className={`flex  items-center ${centerHeading ? '!justify-center' : 'justify-between'
									}`}>
								<Box
									className={`flex flex-col flex-0   ${centerHeading ? 'justify-center items-center' : 'justify-start items-start'
										} ${titleClass ? titleClass : ''}`}>
									<TextWrapper
										type="h6"
										classList="!font-bold"
										text={title}></TextWrapper>
									{subTitle ? (
										<TextWrapper
											type="caption"
											classList="!font-bold !text-[13px]"
											text={subTitle}></TextWrapper>
									) : null}
								</Box>
								{!hideCloseBtn ? (
									<CloseIcon
										onClick={() => {
											onClose();
										}}
										className={`cursor-pointer ${centerHeading ? `absolute !top-[15px]  right-[15px] ` : ''
											}`}></CloseIcon>
								) : null}
							</Box>
						</DialogTitle>
						<DialogContent className={contentClass ? contentClass : ''}>
							<Box>
								{!loading ? (
									<>{content}</>
								) : (
									<Box className="grid grid-flow-row gap-4">
										<Skeleton
											variant="text"
											sx={{ fontSize: '2rem', width: '100%' }}
										/>
										<Skeleton
											variant="text"
											sx={{ fontSize: '2rem', width: '100%' }}
										/>
										<Skeleton
											variant="text"
											sx={{ fontSize: '2rem', width: '100%' }}
										/>
									</Box>
								)}
							</Box>
							<DialogActions className={`!justify-center !mt-4 ${footerClass}`}>
								{!loading ? (
									<>{actions}</>
								) : (
									<Box className="flex flex-auto justify-center items-center">
										<Skeleton
											variant="text"
											sx={{ fontSize: '2rem', width: '150px' }}
										/>
										<Skeleton
											className="!ml-3"
											variant="text"
											sx={{ fontSize: '2rem', width: '150px' }}
										/>
									</Box>
								)}
							</DialogActions>
						</DialogContent>
					</>
				</Box>
			}
		</Dialog>
	);
};
